// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingResponse

import { hydrateWidgetBookingCustomer, type WidgetBookingCustomer, type WidgetBookingCustomerApiResponse } from './widgetBookingCustomer.gen';
import { hydrateCustomerPackageUsage, type CustomerPackageUsage, type CustomerPackageUsageApiResponse } from './customerPackageUsage.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type WidgetBookingApiResponse = {
	id: string;
	pax: number;
	date: string;
	note: string | null;
	offerId: string | null;
	customer: WidgetBookingCustomerApiResponse;
	status: string;
	sessions: Array<{ id: string; startAt: number; endAt: number | null; activityName: string }>;
	customFields: Record<string, string>;
	prices: Record<string, number>;
	packageUsages: CustomerPackageUsageApiResponse[];
	cancellationTimeBefore: number | null;
};

export type WidgetBooking = {
	id: string;
	pax: number;
	date: DateTime;
	note: string | null;
	offerId: string | null;
	customer: WidgetBookingCustomer;
	status: string;
	sessions: Array<{ id: string; startAt: number; endAt: number | null; activityName: string }>;
	customFields: Record<string, string>;
	prices: Record<string, number>;
	packageUsages: CustomerPackageUsage[];
	cancellationTimeBefore: number | null;
};

export function hydrateWidgetBooking(data: WidgetBookingApiResponse): WidgetBooking {
	return {
		...data,
		date: DateTimefromISO(data.date)!,
		customer: hydrateWidgetBookingCustomer(data.customer),
		customFields: Array.isArray(data.customFields) ? {} : data.customFields,
		prices: Array.isArray(data.prices) ? {} : data.prices,
		packageUsages: data.packageUsages.map(hydrateCustomerPackageUsage),
	};
}